export default __webpack_public_path__ + "static/media/check-green.994de5a2.svg";